import Select, { SelectProps } from '@mui/material/Select';

export { Select, SelectProps };
